<script>
import { nlToBr } from '@utils/index'
export default {
  props: {
    future: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    nlToBr(item) {
      return nlToBr(item)
    },
  },
}
</script>
<template>
  <div :class="$style.job">
    <div class="job__box">
      <div class="container">
        <div class="job-box">
          <BaseSectionTitle title="職涯發展" class="text-center" />
          <p class="detail" v-html="nlToBr(future)"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.job {
  :global {
    .job {
      &__box {
        .container {
          .job-box {
            margin: 70px 0px;
            padding-top: 70px;
            padding-bottom: 70px;
            background: var(---ffffff) 0% 0% no-repeat padding-box;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 0px 8px #21455829;
            .detail {
              text-align: center;
              font-size: 1.125rem;
              color: $color-gray-6;
            }
            @include max-md {
              padding: 40px 10px;
              .detail {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>